import { currentRoute } from '@/router';
import { runSearch } from '@/store/catalog';
import { loadOrders } from '@/store/orders';
import { loadDashboard, loadNews } from '@/store/dashboard';

/**
 * Перезагружает данные текущего раздела (для pull-to-refresh и кнопки «Обновить»).
 * Возвращает Promise — индикатор PTR ждёт его завершения.
 */
export function refreshCurrentRoute() {
  switch (currentRoute.value) {
    case 'search':
      return runSearch();
    case 'orders':
      return loadOrders();
    case 'dashboard':
      return Promise.all([loadDashboard(), loadNews()]);
    default:
      return Promise.resolve();
  }
}
